import { sections } from 'modules/communications/constants/sections';

export const communicationsPageInitValue = {
  data: {
    societyName: '',
    totalCommunications: 0,
    totalUnreadCommunications: 0,
    communications: [],
    page: 1,
    hasSignatureView: false,
    senderEmailLocalPart: '',
    senderDomain: '@sttok.com',
    senderName: '',
    replyToEmail: '',
    hasReplyTo: false,
    isValidReplyToEmail: true,
    signatureName: '',
    signatureJobTitle: '',
    signatureLogo: '',
    signatureWebsite: '',
    signaturePhone: '',
    signatureAddress: '',
    signatureFooter: '',
    linkColor: '#000000',
    section: sections.INBOX,
    hasBeenModified: false,
    isAdmin: false,
    isReadOnly: false,
    isLoading: false,
  },
  actions: {
    handleChangePage: () => {},
    handleToggleInboxSection: () => {},
    handleToggleSettingsSection: () => {},
    handleNewCommunication: () => {},
    handleOpenCommunication: () => {},
    handleDeleteCommunication: () => {},
    handleChangeSenderEmailLocalPart: () => {},
    handleChangeSenderName: () => {},
    handleChangeReplyToEmail: () => {},
    handleToggleHasReplyTo: () => {},
    handleChangeSignatureName: () => {},
    handleChangeSignatureJobTitle: () => {},
    handleChangeSignatureWebsite: () => {},
    handleChangeSignaturePhone: () => {},
    handleChangeSignatureAddress: () => {},
    handleChangeSignatureFooter: () => {},
    handleSendTestEmail: () => {},
    handleSaveSettings: () => {},
  },
};
